import { render, staticRenderFns } from "./ot-reset-contract-date-for-pc-dialog.vue?vue&type=template&id=195c77f8&scoped=true&"
import script from "./ot-reset-contract-date-for-pc-dialog.vue?vue&type=script&lang=ts&"
export * from "./ot-reset-contract-date-for-pc-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./ot-reset-contract-date-for-pc-dialog.vue?vue&type=style&index=0&id=195c77f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c77f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VForm,VIcon})
